import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useActor, useInterpret } from '@xstate/react';

import { createFormMachine } from '../machine/machine-factory';
import { FormConfigPropsShape } from './form-props';

const FormServiceContext = React.createContext();

export const useFormService = () => {
  const [formService, config] = useContext(FormServiceContext);
  const [state] = useActor(formService);

  return {
    config,
    state,
    send: formService.send,
  };
};

export const CustomFormService = (props) => {
  const {
    config,
    children,
  } = props;

  const { machineOptions } = config;
  const { machineService } = machineOptions;

  return (
    <FormServiceContext.Provider value={[machineService, config]}>
      {children}
    </FormServiceContext.Provider>
  );
};

CustomFormService.propTypes = {
  config: PropTypes.shape(FormConfigPropsShape).isRequired,
  children: PropTypes.node,
};

CustomFormService.defaultProps = {
  children: null,
};

export const NewFormService = (props) => {
  const {
    config,
    children,
  } = props;

  const { machineOptions, id: machineId } = config;

  const {
    initialState,
    observer,
    ...options
  } = machineOptions;

  const formMachine = useMemo(() => createFormMachine({
    machineId,
    initialState,
    context: { config },
  // useInterpret will listen to options change, so we don't need to create machine again
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }), []);

  const formService = useInterpret(formMachine, options, observer);

  return (
    <FormServiceContext.Provider value={[formService, config]}>
      {children}
    </FormServiceContext.Provider>
  );
};

NewFormService.propTypes = {
  config: PropTypes.shape(FormConfigPropsShape).isRequired,
  children: PropTypes.node,
};

NewFormService.defaultProps = {
  children: null,
};
